import { useT } from "@transifex/react";
import type { TeacherTestDetails } from "p6m-p6u";
import { ButtonColorVariant } from "../../complex/teacherArea/AreaButton";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";
import PDFDownloadButton from "../pdfBasic/PDFDownloadButton/PDFDownloadButton";
import BasePopupWrapper, { TitleColorVariants } from "./BasePopupWrapper";

interface DownloadPdfPopupProps {
    isOpen: boolean;
    onClose: () => void;
    testDetails: TeacherTestDetails;
}

const DownloadPdfPopup = (props: DownloadPdfPopupProps) => {
    const t = useT();

    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const t_downloadPdfTitle = t("Download task as PDF", { _tags: "ClassActivity, ClassActivityPopup" });
    const t_downloadSolution = t("Download solution", { _tags: "ClassActivity, ClassActivityPopup" });
    const t_downloadPdf = t("Download PDF", { _tags: "ClassActivity, ClassActivityPopup" });
    const t_close = t("Close", { _tags: "ClassActivity, ClassActivityPopup" });
    const t_solution = t("Solution", { _tags: "ClassActivity, ClassActivityPopup" });
    const t_test = t("Test", { _tags: "ClassActivity, ClassActivityPopup" });

    const testName = props.testDetails.name ?? t_test;

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={t_downloadPdfTitle}
            titleColor={TitleColorVariants.DEFAULT}
            secondaryButton={{
                text: t_close,
                onClick: props.onClose,
                colorVariant: ButtonColorVariant.DEFAULT,
            }}
        >
            <div className={`flex gap-s flex-wrap ${getStyleBasedOnBreakpoint(Breakpoint.SM, "", "mb-xs")}`}>
                <div className="flex-1">
                    <PDFDownloadButton
                        buttonText={t_downloadSolution}
                        fileName={`${testName} ${t_solution}.pdf`}
                        testDetails={props.testDetails}
                        secondary
                        isSolution
                        fullWidth
                        analyticsSource="download-pdf-popup"
                    />
                </div>
                <div className="flex-1">
                    <PDFDownloadButton
                        buttonText={t_downloadPdf}
                        fileName={`${testName} ${t_test}.pdf`}
                        testDetails={props.testDetails}
                        fullWidth
                        analyticsSource="download-pdf-popup"
                    />
                </div>
            </div>
        </BasePopupWrapper>
    );
};

export default DownloadPdfPopup;
